<template>
  <div class="box margin-top-m">
    <div class="box-content custom-card">
      <div class="flex row middle">
        <span v-if="tooltip" class="info tooltip">
          <span class="tooltiptext">{{ tooltip }}</span>
        </span>
        <div v-if="icon" class="flex-1 middle big-icon" :class="{ 'big-icon2': bigIcon }">
          <div>
            <i :class="`${icon}`"></i>
          </div>
        </div>
        <div class="flex-2">
          <h3 v-if="!money" class="">
            <AnimatedNumber
              :value="value"
              :formatValue="$filters.number"
              :duration="2000"
              :round="true"
              :delay="0"
              easing="easeOutQuart"
            />
            <span v-if="suffix">{{ suffix }}</span>
          </h3>
          <h3 v-else >
            <AnimatedNumber
              :value="value"
              :formatValue="$filters.money"
              :duration="2000"
              :round="true"
              :delay="0"
              easing="easeOutQuart"
            />
            <span v-if="suffix">{{ suffix }}</span>
          </h3>
          <span class="title margin-top-s">{{ label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box-info",
  props: ["label", "tooltip", "value", "money", "icon", "suffix", "currency", "bigIcon"],
  components: {},
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.custom-card {
  min-width: 250px;
  position: relative;
  .big-icon {
    text-align: right;
    i {
      color: var(--primary);
      font-size: 30px;
      margin-right: 16px;
    }
  }
  .big-icon2 {
    text-align: right;
    i {
      color: var(--primary);
      font-size: 44px;
      margin-right: 12px;
    }
  }
  .title {
    white-space: nowrap;
  }
  .info {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 16px;
  }
  h3 {
    font-size: 22px;
    white-space: nowrap;
    //color: var(--primary);
    color: var(--terciary)
  }
  h1 {
    font-size: 48px;
    color: var(--secondary);
  }

  .tooltiptext {
    left: -180px !important;
    top: 21px !important;
  }

  &.negative {
    h1 {
      // color: #ff2727b5 !important;
      color: #fff !important;
    }
  }
}
</style>
